import React from 'react';

const Logo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <img src="/logo.svg" alt="JSkool Logo" className={className} />
  );
};

export default Logo;
